import { domain } from 'modules/data';
import { CustomFieldAccessLevel } from 'shared/constants';

import { messages } from './NetSuiteCustomFields.messages';
import { WorkflowAccessLevelType } from './NetSuiteCustomFields.types';

export const initialCustomField = {
    originalId: null,
    referenceValue: null,
    approvalmaxFieldName: '',
    [WorkflowAccessLevelType.VendorBillWorkflowAccessLevel]: CustomFieldAccessLevel.Editable,
    [WorkflowAccessLevelType.POWorkflowAccessLevel]: CustomFieldAccessLevel.Editable,
    [WorkflowAccessLevelType.ExpenseReportWorkflowAccessLevel]: CustomFieldAccessLevel.Editable,
    [WorkflowAccessLevelType.SalesOrderWorkflowAccessLevel]: CustomFieldAccessLevel.Editable,
    [WorkflowAccessLevelType.VRAWorkflowAccessLevel]: CustomFieldAccessLevel.Editable,
    [WorkflowAccessLevelType.RAWorkflowAccessLevel]: CustomFieldAccessLevel.Editable,
    [WorkflowAccessLevelType.BillPaymentWorkflowAccessLevel]: CustomFieldAccessLevel.Editable,
    [WorkflowAccessLevelType.InvoiceWorkflowAccessLevel]: CustomFieldAccessLevel.Editable,
    [WorkflowAccessLevelType.JournalEntryWorkflowAccessLevel]: CustomFieldAccessLevel.Editable,
    [WorkflowAccessLevelType.VendorWorkflowAccessLevel]: CustomFieldAccessLevel.Editable,
    canClone: false,
    canSplit: false,
    canRemove: true,
    usedInWorkflows: null,
};

export const netSuiteIntegrationCodes: {
    integrationCode: domain.NetSuiteIntegrationCodeType;
    betaFeature?: domain.CompanyBetaFeature;
}[] = [
    {
        integrationCode: domain.IntegrationCode.NetSuiteBill,
    },
    {
        integrationCode: domain.IntegrationCode.NetSuitePO,
    },
    {
        integrationCode: domain.IntegrationCode.NetSuiteExpenseReport,
    },
    {
        integrationCode: domain.IntegrationCode.NetSuiteSalesOrder,
    },
    {
        integrationCode: domain.IntegrationCode.NetSuiteVRA,
    },
    {
        integrationCode: domain.IntegrationCode.NetSuiteRA,
        betaFeature: domain.CompanyBetaFeature.NetSuiteRA,
    },
    {
        integrationCode: domain.IntegrationCode.NetSuiteBillPayment,
    },
    {
        integrationCode: domain.IntegrationCode.NetSuiteInvoice,
    },
    {
        integrationCode: domain.IntegrationCode.NetSuiteJournalEntry,
    },
    {
        integrationCode: domain.IntegrationCode.NetSuiteVendor,
    },
];

export const netSuiteAccessLevelTypes = {
    [domain.IntegrationCode.NetSuiteBill]: WorkflowAccessLevelType.VendorBillWorkflowAccessLevel,
    [domain.IntegrationCode.NetSuitePO]: WorkflowAccessLevelType.POWorkflowAccessLevel,
    [domain.IntegrationCode.NetSuiteExpenseReport]: WorkflowAccessLevelType.ExpenseReportWorkflowAccessLevel,
    [domain.IntegrationCode.NetSuiteSalesOrder]: WorkflowAccessLevelType.SalesOrderWorkflowAccessLevel,
    [domain.IntegrationCode.NetSuiteVRA]: WorkflowAccessLevelType.VRAWorkflowAccessLevel,
    [domain.IntegrationCode.NetSuiteRA]: WorkflowAccessLevelType.RAWorkflowAccessLevel,
    [domain.IntegrationCode.NetSuiteBillPayment]: WorkflowAccessLevelType.BillPaymentWorkflowAccessLevel,
    [domain.IntegrationCode.NetSuiteInvoice]: WorkflowAccessLevelType.InvoiceWorkflowAccessLevel,
    [domain.IntegrationCode.NetSuiteJournalEntry]: WorkflowAccessLevelType.JournalEntryWorkflowAccessLevel,
    [domain.IntegrationCode.NetSuiteVendor]: WorkflowAccessLevelType.VendorWorkflowAccessLevel,
};

export const netSuiteCustomFieldColumnData = {
    [domain.IntegrationCode.NetSuiteBill]: {
        columnId: 'vendorBillWorkflow',
        name: messages.vendorBillWorkflowCol,
        accessLevelType: WorkflowAccessLevelType.VendorBillWorkflowAccessLevel,
    },
    [domain.IntegrationCode.NetSuitePO]: {
        columnId: 'poWorkflow',
        name: messages.poWorkflowCol,
        accessLevelType: WorkflowAccessLevelType.POWorkflowAccessLevel,
    },
    [domain.IntegrationCode.NetSuiteExpenseReport]: {
        columnId: 'expenseReportsWorkflow',
        name: messages.expenseReportsWorkflowCol,
        accessLevelType: WorkflowAccessLevelType.ExpenseReportWorkflowAccessLevel,
    },
    [domain.IntegrationCode.NetSuiteSalesOrder]: {
        columnId: 'salesOrderWorkflow',
        name: messages.salesOrderWorkflowCol,
        accessLevelType: WorkflowAccessLevelType.SalesOrderWorkflowAccessLevel,
    },
    [domain.IntegrationCode.NetSuiteVRA]: {
        columnId: 'vraWorkflow',
        name: messages.vraWorkflowCol,
        accessLevelType: WorkflowAccessLevelType.VRAWorkflowAccessLevel,
    },
    [domain.IntegrationCode.NetSuiteRA]: {
        columnId: 'raWorkflow',
        name: messages.raWorkflowCol,
        accessLevelType: WorkflowAccessLevelType.RAWorkflowAccessLevel,
    },
    [domain.IntegrationCode.NetSuiteBillPayment]: {
        columnId: 'billPaymentWorkflow',
        name: messages.billPaymentWorkflowCol,
        accessLevelType: WorkflowAccessLevelType.BillPaymentWorkflowAccessLevel,
    },
    [domain.IntegrationCode.NetSuiteInvoice]: {
        columnId: 'invoiceWorkflow',
        name: messages.invoiceWorkflowCol,
        accessLevelType: WorkflowAccessLevelType.InvoiceWorkflowAccessLevel,
    },
    [domain.IntegrationCode.NetSuiteJournalEntry]: {
        columnId: 'journalEntryWorkflow',
        name: messages.journalEntryWorkflowCol,
        accessLevelType: WorkflowAccessLevelType.JournalEntryWorkflowAccessLevel,
    },
    [domain.IntegrationCode.NetSuiteVendor]: {
        columnId: 'vendorWorkflow',
        name: messages.vendorWorkflowCol,
        accessLevelType: WorkflowAccessLevelType.VendorWorkflowAccessLevel,
    },
};
